import React, { useEffect, useState } from 'react';

function ImagePlaceholder({
  singleView = false,
  isMobile = false,
}) {
  const [placeholderData, setPlaceholderData] = useState({
    numberOfPlaceholders: 0,
    imagePlaceholderClass: '',
  });

  useEffect(() => {
    let numberOfPlaceholders;
    let imagePlaceholderClass;

    if (singleView || isMobile) {
      numberOfPlaceholders = 1;
      imagePlaceholderClass = 'image-placeholder-single-image';
    } else {
      numberOfPlaceholders = 4;
      imagePlaceholderClass = 'image-placeholder-gallery';
    }

    setPlaceholderData({ numberOfPlaceholders, imagePlaceholderClass });
  }, [isMobile, singleView]);

  return (
    <div
      className="image-placeholder_container"
      data-testid="image-placeholder_container"
    >
      <div className="image-placeholder_wrapper">
        {Array.from({ length: placeholderData.numberOfPlaceholders }).map((_, idx) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={`placeholder-${idx}`}
            className={placeholderData.imagePlaceholderClass}
            aria-hidden="true"
          />
        ))}
      </div>
    </div>
  );
}

export default ImagePlaceholder;
